import { render, staticRenderFns } from "./FaceAddControl.vue?vue&type=template&id=68b95c12&scoped=true&"
import script from "./FaceAddControl.vue?vue&type=script&lang=js&"
export * from "./FaceAddControl.vue?vue&type=script&lang=js&"
import style0 from "./FaceAddControl.vue?vue&type=style&index=0&id=68b95c12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b95c12",
  null
  
)

export default component.exports